import React from 'react';
import c from 'classnames';
import Button from '../../../Button';
import PlusIcon from '@wix/da-ds/pkg/Icons/Plus';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import CoreBadge from '@wix/da-ds/pkg/Badges/CoreBadge';
import s from './PlusIconWithTextButton.scss';
export const PlusIconWithTextButton = ({ withCoreBanner , buttonView , disabled , text , href , onClick  })=>{
    return /*#__PURE__*/ React.createElement(Button, {
        view: buttonView || 'b14',
        height: "medium",
        onClick: onClick,
        href: href,
        disabled: disabled,
        className: s['button']
    }, withCoreBanner && /*#__PURE__*/ React.createElement(CoreBadge, {
        size: "large"
    }), /*#__PURE__*/ React.createElement(PlusIcon, {
        className: c(s['plus-icon'], disabled && s['disabled-icon']),
        size: IconSize.SMALL
    }), text);
};
PlusIconWithTextButton.displayName = 'PlusIconWithTextButton';
export default PlusIconWithTextButton;
